/* eslint no-underscore-dangle: 0 */
import $ from 'jquery';
import { EVENTS } from '../utilities/CONSTANTS';
import { getApiTodoCountUrl } from '../utilities/urlHelper';

const getUserTodoCount = () => $.get(getApiTodoCountUrl())
    .done(({ todo_count = 0, question_count = 0 }) => {
        window._todoCounts = { todoCount: todo_count, questionCount: question_count };
    }).fail((error) => {
        console.error('Error fetching user todo count', error);
        window._todoCounts = { todoCount: 0, questionCount: 0 };
    }).always(() => {
        window.dispatchEvent(new Event(EVENTS.USER_TODO_COUNT));
    });

export default getUserTodoCount;
